/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import { ElTabsetComponent, ElTabComponent } from './tabset.component';
import { ElBadgeModule } from '../badge/badge.module';
import { ElIconModule } from '../icon/icon.module';

const EL_TABSET_COMPONENTS = [
  ElTabsetComponent,
  ElTabComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElBadgeModule,
    ElIconModule,
  ],
  declarations: [
    ...EL_TABSET_COMPONENTS,
  ],
  exports: [
    ...EL_TABSET_COMPONENTS,
  ],
})
export class ElTabsetModule { }
